import React from "react";
import SettingsInfoTip from "./shared/SettingsInfoTip";
import { RECIPIENT_PROFILE_STYLE_OPTIONS } from "./shared/performerRecipientProfile";

/**
 * Draft style picker — compact pills on web and extension.
 *
 * @example
 * <ActionItemsSettingsDraftStyleSection
 *   variant="web"
 *   recipientStyle="concise"
 *   onStyleChange={(id) => setRecipientStyle(id)}
 * />
 */
const ActionItemsSettingsDraftStyleSection = ({
  variant = "web",
  recipientStyle,
  onStyleChange,
}) => {
  const isWeb = variant === "web";

  const toggle = (
    <div className="settings-style-toggle" role="group" aria-label="Draft writing style">
      {RECIPIENT_PROFILE_STYLE_OPTIONS.map((option) => {
        const active = recipientStyle === option.id;
        return (
          <button
            key={option.id}
            type="button"
            className={`settings-style-btn${active ? " settings-style-btn--active" : ""}`}
            aria-pressed={active}
            title={option.description}
            onClick={() => onStyleChange?.(option.id)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );

  if (isWeb) {
    return (
      <div className="settings-general-block settings-general-block--nested">
        <div className="settings-general-block__heading-row">
          <h4 className="settings-general-block__subtitle">Draft style</h4>
          <SettingsInfoTip
            label="About draft style"
            text="Concise: short, direct drafts. Detailed: fuller context with background and next steps."
          />
        </div>
        {toggle}
      </div>
    );
  }

  return (
    <div className="settings-general-piece">
      <p className="settings-general-piece__desc">
        Writing style for AI-generated drafts. See the info tip for examples.
      </p>
      <div className="settings-general-piece__heading-row">
        <span className="settings-general-piece__label">Draft style</span>
        <SettingsInfoTip
          label="About draft style"
          text="Concise: short, direct drafts. Detailed: fuller context with background and next steps."
        />
      </div>
      {toggle}
    </div>
  );
};

export default ActionItemsSettingsDraftStyleSection;
